import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _path;
const _excluded = ["size", "title", "titleId"];
import * as React from 'react';
import PropTypes from 'prop-types';
import { sizes, sizeMap, useId } from './utils';
function FileDownload(_ref) {
  let {
      size: sizeProp,
      title,
      titleId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const size = sizeMap.get(sizeProp);
  titleId = useId(titleId);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size.width,
    height: size.height,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#212429",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 7.781V3H5.844A.842.842 0 005 3.844v16.312c0 .468.376.844.844.844h11.812a.842.842 0 00.844-.844V8.625h-4.781a.846.846 0 01-.844-.844zm2.688 7.43l-3.39 3.365a.6.6 0 01-.845 0l-3.39-3.364a.562.562 0 01.396-.962h2.291v-2.813c0-.31.252-.562.563-.562h1.124c.311 0 .563.252.563.563v2.812h2.291c.502 0 .753.608.397.962zm2.69-8.52l-3.44-3.445A.843.843 0 0014.213 3H14v4.5h4.5v-.214a.841.841 0 00-.246-.595z"
  })));
}
FileDownload.sizes = sizes;
FileDownload.defaultProps = {
  size: sizes.md
};
FileDownload.propTypes = {
  size: PropTypes.oneOf([FileDownload.sizes.xs, FileDownload.sizes.sm, FileDownload.sizes.md, FileDownload.sizes.lg, FileDownload.sizes.xl]),
  titleId: PropTypes.string,
  title: PropTypes.string.isRequired
};
export default FileDownload;